module.exports = __webpack_public_path__ + "img/sticker_17.0d985856.svg";